import tagCloudView from './tagCloudView.html';
import './tagCloud.css';
import _ from 'lodash';

export default function tagCloudComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {
			tagCloudData: '=',
			emptyMessage: '@',
		},
		controllerAs: 'vm',
		controller: tagCloudComponentCtrl,
		template: tagCloudView,
	};
}

class tagCloudComponentCtrl {
	constructor($scope) {
		'ngInject';
		this.cloudData = [];

		$scope.$watch('vm.tagCloudData', () => {
			this.setTagSize();
		});
	}

	setTagSize() {
		if (!Array.isArray(this.tagCloudData)) {
			this.cloudData = [];
			return;
		}

		let maxTag = _.max(this.tagCloudData, tag => parseInt(tag.posts, 10));
		let max = maxTag.posts;
		let largestFontSize = 24;
		let smallestFontSize = 10;
		let highestOpacity = 1;
		let lowestOpacity = 0.5;

		this.cloudData = this.tagCloudData.map(tag => {
			let factor = (max - tag.posts + 1) / max;
			tag.size = _.round(largestFontSize - smallestFontSize * factor, 1);
			tag.opacity = _.round(highestOpacity - lowestOpacity * factor, 2);
			tag.link = '/posts/intelligence/?term=' + encodeURIComponent('#' + tag.name);
			return tag;
		});
	}

	// This is so the anchor tag in the tag cloud doesn't go anywhere
	tagClicked(e) {
		e.preventDefault();
	}
}
